import React from 'react';
import { Box, Flex } from 'components/ReflexBox';

import { H3, H5 } from 'components/Typo';
import Icon from 'components/Icon';

// const Item = ({ label }) => (
//   <Box width={[1, 1 / 2]} pr={[0, 3]} pl={0} mb={3}>
//     <Flex width={1} bg="sectionBackground" px={3} py={1} alignItems="center">
//       <H4 as="div">{label}</H4>
//       <Icon width="24px" ml="auto" name={icon} />
//     </Flex>
//   </Box>
// );

export default ({ items = [], ...rest }) => {
  return (
    <Box {...rest}>
      <H3 as="div">Technology Stack</H3>
      <Flex mx={-1} flexWrap="wrap">
        {items.map((item) => (
          <Box
            mr={2}
            px={2}
            py={1}
            bg="sectionBackground"
            key={item}
            css={{ borderRadius: 3 }}
          >
            <strong>{item}</strong>
          </Box>
        ))}
      </Flex>
    </Box>
  );
};
